import React from 'react';
import BrandLogo from './BrandLogo';
import MotionReveal from '../motion/MotionReveal';

const HUBS = [
  { id: 'in', label: 'India', role: 'HQ & Primary Manufacturing' },
  { id: 'ae', label: 'UAE', role: 'Middle East & Africa Hub' },
  { id: 'sg', label: 'Singapore', role: 'Southeast Asia Sales & Technical' },
];

const STATS = [
  { v: '25+', l: 'Countries Served' },
  { v: '2,400+', l: 'Formulations' },
  { v: '15K', l: 'MT / Year Capacity' },
  { v: '24h', l: 'Response Time' },
];

export default function GlobalPresence() {
  return (
    <MotionReveal className="global-presence">
      <div className="gp-stats">
        {STATS.map((s) => (
          <div key={s.l} className="gp-stat">
            <div className="gp-stat__v">{s.v}</div>
            <div className="gp-stat__l">{s.l}</div>
          </div>
        ))}
      </div>
      <div className="gp-map-wrap">
        <div className="gp-logo-cell">
          <BrandLogo placement="nav" className="gp-logo" alt="Auralux" />
        </div>
        <ul className="gp-hubs">
          {HUBS.map((h) => (
            <li key={h.id}>
              <strong>{h.label}</strong>
              <span>{h.role}</span>
            </li>
          ))}
        </ul>
      </div>
    </MotionReveal>
  );
}
